<template>
  <div>
    <v-container>
      <h1 class="mb-2 text-center">
        {{ $t('select_business') }}
      </h1>
    </v-container>

    <v-container fluid>
      <v-row justify="center" class="pa-4" v-if="!loadingProfile">
        <!-- Add Button -->
        <v-col cols="12" sm="4" md="2">
          <v-tooltip bottom v-if="connectedProfiles.length >= maxBusiness">
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <div
                  class="hover"
                  style="width: 80%; margin: auto; filter: contrast(0.8)"
                >
                  <v-avatar
                    tile
                    :size="100"
                    class="mx-auto"
                    style="
                      width: 100%;
                      aspect-ratio: 1;
                      border-radius: 8px;
                      object-fit: cover;
                    "
                  >
                    <img src="/img/page-plus.svg" alt="add-button" />
                  </v-avatar>
                  <div class="text-center mt-2">
                    {{ $t('add_field') }}
                  </div>
                </div>
              </div>
            </template>
            <span>{{ $t('business_reach_limit') }}</span>
          </v-tooltip>
          <div v-else>
            <div
              class="hover"
              @click="handleAddBusiness({ open: true, isCreateProfile: false })"
              style="width: 80%; margin: auto; filter: contrast(0.8)"
            >
              <v-avatar
                tile
                :size="100"
                class="mx-auto"
                style="
                  width: 100%;
                  aspect-ratio: 1;
                  border-radius: 8px;
                  object-fit: cover;
                  height: auto;
                "
              >
                <img src="/img/page-plus.svg" alt="add-button" />
              </v-avatar>
              <div class="text-center mt-2">
                {{ $t('add_field') }}
              </div>
            </div>
          </div>
        </v-col>

        <!-- Profile Cards -->
        <v-col
          cols="12"
          sm="4"
          md="2"
          v-for="(item, index) in connectedProfiles"
          :key="index"
          v-if="item.id"
        >
          <div
            class="hover"
            @click="handleClickMenuToChecklist(item)"
            style="
              width: 80%;
              margin: auto;
              position: relative;
              overflow: hidden;
            "
          >
            <VerifyBusinessAction
              v-if="
                item.email_validation_status &&
                item.email_validation_status.status_description === 'PENDING'
              "
              :channelId="item.id"
              @accept="getProfileSelection()"
              @decline="getProfileSelection()"
            />
            <v-avatar
              v-if="item.picture_url"
              tile
              class="mx-auto"
              style="
                width: 100%;
                aspect-ratio: 1;
                border-radius: 20px;
                object-fit: cover;
                box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.2);
                height: auto;
                border-radius: 8px !important;
              "
            >
              <img :src="item.picture_url" alt="" />
            </v-avatar>
            <v-img
              v-else
              aspect-ratio="1"
              contain
              style="
                background-color: #e0e0e0;
                text-align: center;
                border-radius: 8px !important;
              "
            >
              <template #placeholder>
                <v-icon size="90" style="width: 100px; height: 100%"
                  >mdi-account</v-icon
                >
              </template>
            </v-img>
            <div
              class="mt-2 text-center"
              style="
                font-size: large;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              "
            >
              {{ item.name }}
            </div>
          </div>
        </v-col>
      </v-row>

      <!-- Pagination -->
      <v-row justify="center" v-if="!isDisablePagination">
        <v-pagination
          v-model="page"
          :length="paginationCount"
          color="primary"
          class="mt-4"
        />
      </v-row>

      <!-- Dialog -->
      <v-dialog v-model="businessDialog.open" max-width="600">
        <v-card>
          <v-card-text>
            <BusinessDialog
              :maxBusiness="maxBusiness"
              :profileSelection="profileSelection"
              :getProfileSelectionData="getProfileSelection"
              :isCreateProfile="businessDialog.isCreateProfile"
              :isConnectApp="businessDialog.isConnectApp"
              :onClose="() => (businessDialog.open = false)"
            />
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import BusinessDialog from '../components/business/BusinessDialog.vue'
import VerifyBusinessAction from '../components/business/VerifyBusinessAction.vue'
export default {
  components: {
    BusinessDialog,
    VerifyBusinessAction
  },
  data: () => ({
    appId: 7,
    loadingProfile: false,
    profileSelection: {},
    connectedProfiles: [],
    page: 1,
    paginationCount: 5,
    isDisablePagination: true,
    maxBusiness: 30,
    businessDialog: {
      open: false,
      isCreateProfile: false,
      isConnectApp: false
    }
  }),
  async mounted() {
    await this.getProfileSelection()

    const params = new URLSearchParams(window.location.search)
    const businessId = params.get('business_id')
    if (businessId) {
      const path = `/${this.currentLang}/home?business_id=${businessId}`
      window.location.href = path
    }
  },
  methods: {
    async getProfileSelection() {
      try {
        this.$store.dispatch('setOverlay', true)
        var res = await this.$store.dispatch('ssoAccount/getBusinessProfile', {
          page_size: 9999999,
          priority: `app:${this.appId}`
        })
        if (res && res.data && res.data.result) {
          this.profileSelection = res.data.result
          var allProfiles = this.profileSelection.channel_profile

          if (!allProfiles.length) {
            this.handleAddBusiness({ open: true, isCreateProfile: true })
            return
          }

          this.connectedProfiles = allProfiles.filter((f) =>
            f.channel_profile_connect.find((c) => c.id === this.appId)
          )

          if (!this.connectedProfiles.length) {
            this.handleAddBusiness({ open: true, isCreateProfile: false })
            return
          } else if (this.connectedProfiles.length === 1) {
            const preventAutoSelect = sessionStorage.getItem(
              'preventAutoSelectBusiness'
            )
            if (!preventAutoSelect) {
              this.handleClickMenuToChecklist(this.connectedProfiles[0])
              return
            }
          }
        } else {
          this.$notify({
            group: 'foo',
            type: 'error',
            title: 'Error',
            text: `Something went wrong.`
          })
        }
      } finally {
        this.$store.dispatch('setOverlay', false)
      }
    },
    handleAddBusiness({ open, isCreateProfile, isConnectApp }) {
      this.businessDialog.isCreateProfile = isCreateProfile
      this.businessDialog.isConnectApp = isConnectApp
      this.businessDialog.open = open
    },
    handleClickMenuToChecklist(item) {
      const path = `/${this.currentLang}/home?business_id=${item.id}`
      window.location.href = path
    }
  }
}
</script>
